import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function CheckoutRedirect() {
  const [searchParams] = useSearchParams();
  const checkoutUrl = searchParams.get('checkout_url');
  const hasOpenedRef = useRef(false);

  useEffect(() => {
    if (checkoutUrl && !hasOpenedRef.current) {
      hasOpenedRef.current = true;
      // Attempt to open in a new tab
      window.open(checkoutUrl, '_blank');
    }
  }, [checkoutUrl]);

  if (!checkoutUrl) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Invalid Checkout Link</h2>
        <p>No redirection URL was provided.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Opening Checkout...</h2>
      <p>If your payment page did not open automatically, click the button below:</p>
      <a
        href={checkoutUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          marginTop: '1rem',
          padding: '0.75rem 1.5rem',
          backgroundColor: '#0070f3',
          color: '#fff',
          borderRadius: '6px',
          textDecoration: 'none',
          fontWeight: 'bold',
        }}
      >
        Proceed to Payment
      </a>
    </div>
  );
}